<!--
 * @Description  : 安招采-协会专家库承诺书 审核
 * @Author       : wuxuebing
 * @Date         : 2025-03-26 11:09:16
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-16 14:23:11
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\audit-affairs-new\components\expert-dialog.vue
-->
<template>
	<!-- 安招采-协会专家库承诺书 审核 -->
	<el-dialog :visible.sync="expertDialog.visible" :title="expertDialog.title" center width="800px" top="5vh" @closed="dialogClose">
		<el-form :model="expertForm" ref="expertForm" class="expertStyle" size="small" v-if="expertDialog.visible">
			<el-form-item label="申请的企业：">
				{{ expertForm.appliedEnterprise }}
			</el-form-item>
			<el-form-item label="主体身份类型：">
				<el-checkbox-group v-model="expertForm.subjectIdType" class="flex">
					<el-checkbox v-for="(item, index) in qyztlx" :label="item.value" :key="index" class="mr20" disabled
						>{{ item.sname }}
					</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="业务要求：">
				{{ expertForm.businessRequirement }}
			</el-form-item>
			<el-form-item label="承诺书附件：" class="bottom-style">
				<public-upload ref="upload" :isViewMode="true" listType="text" :viewFilesList="viewFilesList"></public-upload>
			</el-form-item>

			<el-form-item label="申请人姓名：">
				{{ expertForm.applyUserName }}
			</el-form-item>
			<el-form-item label="申请人证件类型：">
				{{ expertForm.ApplyIdType }}
			</el-form-item>
			<el-form-item label="申请人证件号：">
				{{ expertForm.ApplyIdNum }}
			</el-form-item>

			<el-form-item label="申请时间：" class="bottom-style">
				{{ expertForm.createDate }}
			</el-form-item>

			<el-form-item label="审核结果：">
				{{ expertForm.auditResult }}
			</el-form-item>
			<el-form-item label="审核意见：">
				{{ expertForm.auditOpinion }}
			</el-form-item>
			<el-form-item label="审核人：">
				{{ expertForm.auditPerson }}
			</el-form-item>

			<el-form-item label="审核时间：">
				{{ expertForm.auditDate }}
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
import * as API from 'api/modules/audit'
import { mapState } from 'vuex'
export default {
	props: {},
	components: {},
	data() {
		return {
			expertDialog: {
				visible: false,
				title: '安招采-协会专家库承诺书 审核',
				mode: 'audit',
				btnLoading: false
			},
			viewFilesList: [], // 承诺书附件
			expertForm: {} // 专家表单
		}
	},

	methods: {
		// 弹窗打开
		dialogOpen(id) {
			API.getRecordDetail({
				recordId: id,
				id
			}).then((res) => {
				this.expertForm = { ...res.data } // 使用浅拷贝避免直接修改响应数据
				this.expertForm.subjectIdType = res.data.subjectIdType.split(',')
				let regex = /\/group1(?:\/.*)?/
				this.viewFilesList = res.data.commitLetterList.map((item) => {
					let fileDirectory = ''
					if (item.commitLetterUrl && regex.test(item.commitLetterUrl)) {
						fileDirectory = item.commitLetterUrl.match(regex)[0]
						// 找到最后一个 '/' 的位置
						const lastSlashIndex = fileDirectory.lastIndexOf('/')

						// 截取从开始到最后一个 '/'（包含该 '/'）的部分
						fileDirectory = fileDirectory.slice(0, lastSlashIndex + 1)
					}

					return {
						fileName: item.commitLetterName,
						fileDirectory: fileDirectory,
						id: item.commitLetterName
					}
				})
			})

			this.expertDialog.visible = true
		},

		// 弹窗关闭
		dialogClose() {
			// 重置所有数据
			Object.assign(this.$data, this.$options.data())
			this.expertDialog.visible = false
		}
	},
	computed: {
		...mapState('dict', {
			qyztlx: (state) => state.qyztlx
		})
	}
}
</script>

<style lang="less" scoped>
.bottom-style {
	border-bottom: 1px dashed #ddd;
}

/deep/.el-form-item {
	margin-bottom: 2px;
}

/deep/.view-layout {
	min-height: 20px;
}
</style>
